import React, { useState } from 'react'

import {
  Button, ChevronDown, ClosingDropdown, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string } from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import getSelectedFilters from 'Utils/getSelectedFilters'

import SubscriptionTier from './Components/SubscriptionTier'
import {
  buildTierClearUpdate, buildTierFilterUpdate, getSelectedTier, TIER_ALL, TIER_FILTER_KEY, TIER_PLAN_NAMES,
} from './subscriptionTierFilters'

const chevronDownIcon = <Icon svgComponent={ChevronDown} color="dark" notSpaced />

function SubscriptionFilter({
  label,
  selectedFilters,
  setSelectedFilters,
  trackFilterChange,
  subscriberTier = null,
  locale = 'en',
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)

  const selectedTier = getSelectedTier(
    selectedFilters[TIER_FILTER_KEY],
    getSelectedFilters(selectedFilters.pricing || [])
  )
  const allLabel = i18n.t('listingPage.filters.subscriptionTier.all', { ns: 'rails', lng: locale })
  const selectedTierLabel = selectedTier === TIER_ALL ? allLabel : TIER_PLAN_NAMES[selectedTier]
  const buttonLabel = selectedTier ? `${label}: ${selectedTierLabel}` : label

  // Radio semantics: drop the previous tier so the tracked search state holds only the current one.
  // The dropdown stays open: arrow keys change the checked radio, and closing would drop keyboard focus.
  function handleTierChange(tier) {
    window.removeCurrentSearchFilter({ name: 'subscriptionTier' })
    setSelectedFilters(buildTierFilterUpdate(tier, selectedFilters))
    trackFilterChange({ name: 'subscriptionTier', value: tier })
  }

  function handleTierClear() {
    window.removeCurrentSearchFilter({ name: 'subscriptionTier' })
    setSelectedFilters(buildTierClearUpdate(selectedFilters))
    setTriggerCloseDropdown(true)
  }

  return (
    <ClosingDropdown
      content={(
        <SubscriptionTier
          selectedTier={selectedTier}
          subscriberTier={subscriberTier}
          onChange={handleTierChange}
          onClear={handleTierClear}
          name="listing-subscription-tier"
          locale={locale}
        />
      )}
      isSimpleContent
      isSpaced
      onOpenChange={setIsOpen}
      className="subscription-filter"
      contentClassName="subscription-filter__content"
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
      withBackdrop
    >
      <Button
        type="secondary"
        size="medium"
        actionType="button"
        customClass="filters-wrapper-with-buttons__button subscription-filter__button"
        isActive={!!selectedTier}
        trailIcon={chevronDownIcon}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        {buttonLabel}
      </Button>
    </ClosingDropdown>
  )
}

SubscriptionFilter.propTypes = {
  label: string.isRequired,
  selectedFilters: object.isRequired,
  setSelectedFilters: func.isRequired,
  trackFilterChange: func.isRequired,
  subscriberTier: string,
  locale: string,
}

const mapStateToProps = ({
  selectedFilters,
  setSelectedFilters,
  trackFilterChange,
  subscriberTier,
  locale,
}) => ({
  selectedFilters,
  setSelectedFilters,
  trackFilterChange,
  subscriberTier,
  locale,
})

export default WithTriangleUiContext(mapStateToProps)(SubscriptionFilter)
